export default __webpack_public_path__ + "static/media/79.4da7d4ba.png";